import React from "react";
import { Tag } from "antd";
import { getRangeStatus } from "utils/jepsonRegions";

interface Props {
  bioregionalDistributions: string | null | undefined;
  matchedRegions: string[];
}

const RangeStatusCell = ({ bioregionalDistributions, matchedRegions }: Props) => {
  const status = getRangeStatus(bioregionalDistributions, matchedRegions);

  if (status === "in-range") {
    return <Tag color="success">In Range</Tag>;
  }
  if (status === "out-of-range") {
    return <Tag color="warning">Out of Range</Tag>;
  }
  return <Tag color="default">Unknown</Tag>;
};

export default RangeStatusCell;
